<template>

  <div class="sm-sort sm-sort_faded" key="sm-sort">
    <div class="sm-screen sm-screen_tiny">
      <div class="sm-screen__actions sm-screen__actions_top">
        <div class="sm-screen__slot sm-screen__slot_l"></div>
        <div class="sm-screen__slot"><span class="sm-screen__title">Сортировка</span></div>
        <div class="sm-screen__slot sm-screen__slot_r">
          <button @click="setShowSortMobile(false)" class="sm-screen__button sm-screen__button_f-small">
            Закрыть
          </button>
        </div>
      </div>
      <div class="sm-screen__content">

        <button v-for="option in options" :key="option.name"
                class="sm-sort__button"
                :disabled="option.name===sort"
                :class="{'sm-sort__button_active': option.name===sort}"
                @click="setSortOption(option)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  name: "sm-sort-mobile",
  data () {
    return {
      currentOption: this.sort,
      options: [
        { label: 'По популярности', name: 'default'},
        { label: 'Сначала дешевле', name: 'price_asc' },
        { label: 'Сначала дороже', name: 'price_desc'}
      ]
    }
  },
  computed: {
    ...mapState("search", ["sort"])
  },
  methods: {
    ...mapActions("search", [
        "setShowSortMobile",
        "sendSortSelectEvent",
        "renderInstantSearch",
        "sendSortOpenEvent",
        "setSort",
        "setPagination"
    ]),
    setSortOption: function (option) {
      this.setSort(option.name);
      this.sendSortSelectEvent();
      this.setShowSortMobile(false);
      this.setPagination({ currentPage: 1 });
    },
  }
}
</script>